import { streamKeysToCvent } from '../../../../locales/streamChat/translationUtil';

export const chatLocalization = async (locale, localeObject) => {
  const translationsForLanguage = Object.keys(streamKeysToCvent).reduce(
    (acc, key) => ({
      ...acc,
      [key]:
        localeObject[streamKeysToCvent[key]] ||
        // fall back to default if override is not configured, mainly for storybook
        localeObject.default[streamKeysToCvent[key]]
    }),
    {}
  );

  const { Streami18n } = await import('stream-chat-react');
  // Stream requires locale to be just the characters before the '-'.
  // Anything other than that would not translate the dateSeparator text
  const streamLocale = locale.split('-')[0];

  const translator = new Streami18n({
    language: streamLocale,
    translationsForLanguage
    // TODO: re-enable when race-condition with Stream is fixed
    // DateTimeParser: Moment
  });
  // Register the translations with the base locale as well so that Stream can fall back to our translations
  translator.registerTranslation(streamLocale, translationsForLanguage);
  translator.setLanguage(streamLocale);
  return translator;
};
